import type { CalificacionType } from '@/types/types';

export const calColors: Record<CalificacionType, string> = {
  C: 'bg-green-100 text-green-800 border-green-300',
  NC: 'bg-red-100 text-red-800 border-red-300',
  CP: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  NA: 'bg-gray-100 text-gray-600 border-gray-300',
};

export function CalificacionBadge({ cal, prev }: { cal: CalificacionType | null; prev?: CalificacionType | null }) {
  if (!cal) return null;
  const hasDiff = prev && prev !== cal;

  return (
    <div className={`flex items-center gap-1.5 mt-2.5 ${hasDiff ? 'animate-in zoom-in-95' : ''}`}>
      {hasDiff && (
        <>
          <span className="px-1.5 py-0.5 rounded text-[9px] border border-gray-200 bg-gray-50/50 text-gray-400 line-through opacity-60 italic">
            {prev}
          </span>
          <span className="text-blue-400 text-[11px] font-bold">→</span>
        </>
      )}
      <span
        className={`px-2 py-0.5 rounded text-[10px] font-bold border shadow-sm ${calColors[cal]} ${hasDiff ? 'ring-2 ring-blue-500/20 ring-offset-1 border-blue-200' : ''}`}
      >
        {cal}
      </span>
    </div>
  );
}
